// extracted by mini-css-extract-plugin
export var alert = "styles-module--alert--d828f";
export var icon = "styles-module--icon--38981";
export var text = "styles-module--text--34bfe";
export var textSvg = "styles-module--textSvg--2f275";